
<div class="container">
  <div class="row">
    <div class="col">
      <p>Optional: print the work order for all the assets on the deployment.</p>
    </div>
  </div>
  <div class="row">
    <div class="col"> </div>
    <div class="col"><a class="btn btn-primary btn-block" id="printWorkOrders" [href]="'/api/deploymentworkflow/print-work-orders?deploymentId=' + deploymentId" target="_blank" (click)="setComplete()"><span class="oi oi-cloud-download"></span> Print Work orders</a></div>
    <div class="col"> </div>
  </div>
</div>